module.exports = __webpack_public_path__ + "fb-tutorial-5-en.png?cb9eaea389042d3e13a09083c7e643d9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-5-en.png
// module id = mVAg
// module chunks = 50